export function receivedPublicProjectList(projectList) {
  return {type: 'RECEIVED_PUBLIC_PROJECT_LIST', projectList};
}

export function receivedProjectList(projectList, deletedId) {
  return (dispatch, _getState, {repository}) => {
    if (deletedId) dispatch({type: 'DELETED_PROJECT', project: {id: deletedId}});
    dispatch({type: 'RECEIVED_PROJECT_LIST', projectList});
    repository.persistProject();
  }
}

export function receivedProject(project, tempId=project.id) {
  return (dispatch, _getState, {repository}) => {
    try {
      dispatch({type: 'RECEIVED_PROJECT', project, tempId});
      repository.persistProject();
    } catch (e) {
      console.warn('RECEIVED_PROJECT dispatch error', e.toString());
      throw e;
    }
  };
}

export function createProjectOffline(project) {
  return (dispatch, _g, {repository}) => {
    let offlineProject = project;
    if (!project.createdOfflineAt) {
      offlineProject = {
        id: _.uuid(),
        createdOfflineAt: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        ...project
      };
    }
    dispatch(receivedProject(offlineProject));
    repository.persistProject();
    return offlineProject;
  };
}

export function updateProjectOffline(project) {
  return (dispatch, _g, {repository}) => {
    const updatedProject = {
      type: 'RECEIVED_PROJECT',
      project: {
        ...project,
        updatedOfflineAt: new Date().toISOString()
      }
    }
    dispatch(updatedProject);
    repository.persistProject();
    return updatedProject;
  };
}

export function deleteProjectOffline(projectId){
  return (dispatch, _g, {repository}) => {
    dispatch({type: 'MARK_PROJECT_DELETED', projectId});
    repository.persistProject();
  };
}

export function newRegistration(registration) {
  return async (dispatch, _getState, {api}) => {
    dispatch({type: 'NEW_REGISTRATION', registration});
    try {
      await api.initializeAppData();
    } catch(e) {
      if (e instanceof APIError) {
        console.warn(e);
      } else {
        throw e;
      }
    }
  };
}

export function registrationError(body) {
  return {type: 'REGISTRATION_ERROR', errors: body?.errors};
}

export function userUpdateError(body) {
  return {type: 'USER_UPDATE_ERROR', errors: body?.errors};
}

export function newAcceptance(acceptance) {
  return {type: 'ACCEPTANCE', acceptance};
}

export function receivedProductTypes(productTypeList) {
  return {type: 'RECEIVED_PRODUCT_TYPE_LIST', productTypeList};
}

export function receivedCurrentUser(userInfo) {
  return {type: 'RECEIVED_USER_INFO', userInfo};
}

export function receivedPasswordReset({code, token}) {
  return {type: 'RECEIVED_PASSWORD_RESET', code, token};
}

export function receivedPushPierProducts(products) {
  return {type: 'pushPierProducts/received', products};
}

export function receivedRamProducts(products) {
  return {type: 'ramProducts/received', products};
}

export function receivedAccessToken(token, email, userInfo) {
  return {type: 'LOGIN', token, email, userInfo};
}

export function receivedLoginError(body) {
  const errors = _.get(body, 'errors', body);
  return {type: 'AUTHENTICATION_ERROR', errors};
}

export function receivedDestroyError(body) {
  const errors = _.get(body, 'errors');
  return {type: 'DESTRUCTION_ERROR', errors};
}

export function newDestroyRequest(_body) {
  return {type: 'DESTRUCTION_REQUEST'};
}

export function destroyedUser(_body) {
  return {type: 'DESTROYED_USER'};
}

const ServerActions = {
  receivedPublicProjectList,
  receivedProjectList,
  receivedProject,
  createProjectOffline,
  updateProjectOffline,
  deleteProjectOffline,
  newRegistration,
  registrationError,
  userUpdateError,
  newAcceptance,
  receivedProductTypes,
  receivedCurrentUser,
  receivedPasswordReset,
  receivedPushPierProducts,
  receivedRamProducts,
  receivedAccessToken,
  receivedLoginError,
  receivedDestroyError,
  newDestroyRequest,
  destroyedUser,
};

export default ServerActions;
